import { loincCoding } from '#src/models/loinc.ts'
import {
  STEADI_YES_NO_1_ANSWERS,
  STEADI_YES_NO_2_ANSWERS,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    items: [
      ['52552-7', 'I have fallen in the past year', STEADI_YES_NO_2_ANSWERS],
      [
        '97875-9',
        'I use or have been advised to use a cane or walker to get around safely',
        STEADI_YES_NO_2_ANSWERS,
      ],
      ['97876-7', 'Sometimes I feel unsteady when I am walking'],
      [
        '97877-5',
        'I steady myself by holding onto furniture when walking at home',
      ],
      ['97878-3', 'I am worried about falling'],
      ['97879-1', 'I need to push with my hands to stand up from a chair'],
      ['97880-9', 'I have some trouble stepping up onto a curb'],
      ['97881-7', 'I often have to rush to the toilet'],
      ['97882-5', 'I have lost some feeling in my feet'],
      [
        '97883-3',
        'I take medicine that sometimes makes me feel light-headed or more tired than usual',
      ],
      ['97884-1', 'I take medicine to help me sleep or improve my mood'],
      ['48527-6', 'I often feel sad or depressed'],
    ].map(([code, label, answerSet = STEADI_YES_NO_1_ANSWERS]) =>
      scoredItem(loincCoding(code, label), answerSet)
    ),
  },
]

export const STEADI_TEMPLATE: InstrumentTemplate = {
  id: 'steadi',
  version: '1',
  panel: loincCoding('97874-2', 'Stay Independent panel [Stay Independent]'),
  title: 'Stay Independent panel [Stay Independent]',
  shortName: 'STEADI',
  reference:
    'https://www.cdc.gov/steadi/pdf/steadi-brochure-stayindependent-508.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'steadi',
    coding: loincCoding('97885-8', 'Stay Independent total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    // The brochure's cut-off: 4 or more points may mean a risk of falling.
    bands: [
      scoreBand(
        { min: 0, max: 3 },
        'steadi-low-risk',
        'Low Fall Risk',
        'green'
      ),
      scoreBand({ min: 4 }, 'steadi-at-risk', 'At Risk of Falling', 'red'),
    ],
  }),
}
